import { SITE_CONFIG } from "../../app/config";
import { useHead, buildPersonaSchema } from "../../seo";
import { personaBySlug } from "./persona-data";

type PersonaPageProps = {
  slug: string;
};

export const PersonaPage = ({ slug }: PersonaPageProps): JSX.Element => {
  const persona = personaBySlug.get(slug);

  if (!persona) {
    return (
      <div className="shell">
        <div className="pseo-page">
          <header className="pseo-header">
            <a href="/" className="blog-back">← Back to {SITE_CONFIG.name}</a>
            <h1 className="pseo-title">Page Not Found</h1>
            <p className="pseo-subtitle">
              This page doesn't exist.{" "}
              <a href="/">Go to {SITE_CONFIG.name} →</a>
            </p>
          </header>
        </div>
      </div>
    );
  }

  useHead({
    title: persona.metaTitle,
    description: persona.metaDescription,
    path: `/for/${persona.slug}`,
    ogType: "article",
    jsonLd: buildPersonaSchema({
      title: persona.metaTitle,
      description: persona.metaDescription,
      path: `/for/${persona.slug}`,
      persona: persona.persona,
    }),
  });

  return (
    <div className="shell">
      <div className="pseo-page">
        <header className="pseo-header">
          <a href="/" className="blog-back">
            ← Back to {SITE_CONFIG.name}
          </a>
          <div className="persona-badge">{persona.persona}</div>
          <h1 className="pseo-title">{persona.heroTitle}</h1>
          <p className="pseo-subtitle">{persona.heroSubtitle}</p>
        </header>

        <article className="persona-content">
          {persona.sections.map((section, i) => (
            <section key={i} className="persona-section">
              <h2>
                <span className="persona-section-icon">{section.icon}</span>
                {section.heading}
              </h2>
              {section.content.map((p, j) => (
                <p key={j}>{p}</p>
              ))}
            </section>
          ))}

          {/* Quick Tips */}
          <section className="persona-tips">
            <h2>Quick Tips</h2>
            <ul>
              {persona.quickTips.map((tip, i) => (
                <li key={i}>{tip}</li>
              ))}
            </ul>
          </section>
        </article>

        <footer className="pseo-footer">
          <div className="blog-cta">
            <h3>Ready to Go Offline?</h3>
            <p>{persona.ctaText}</p>
            <a href="/" className="blog-cta-button">
              Try {SITE_CONFIG.name} Free →
            </a>
          </div>
          <div className="pseo-nav-links">
            <a href="/glossary">Music Glossary</a>
            <a href="/compare">Compare Formats</a>
            <a href="/blog">Blog</a>
            <a href="/">Home</a>
          </div>
        </footer>
      </div>
    </div>
  );
};
